<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Nuevo Camión">
          <b-form @submit.prevent="send">
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Placa*</label>
                <input type="text" v-model="truck.plate" class="form-control" required />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Celular*</label>
                <input type="text" v-model="truck.mobile" class="form-control" required />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>IMEI*</label>
                <input type="text" v-model="truck.imei" class="form-control" required />
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Servicio*</label>
                <select v-model="truck.service_id" class="form-control" required>
                  <option
                    v-for="(service_type, k) in service_types"
                    :key="k"
                    :value="service_type.id"
                  >{{service_type.name}}</option>
                </select>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Proveedor*</label>
                <v-select
                  :value="truck.provider"
                  :options="providers"
                  label="name"
                  :on-change="setProvider"
                ></v-select>
              </b-col>
            </b-row>
            
            <b-row class="form-group">
              <b-col sm="5">
                <label for>Equipo</label>
                <v-select
                  :value="truck.team"
                  :options="teams"
                  label="name"
                  :on-change="setTeam"
                ></v-select>
              </b-col>
            </b-row>

            <b-row  v-if="!truck.provider.owner" class="form-group">
              <b-col sm="5">
                <label for=""><strong>Modalidad</strong></label><br>
                <input type="radio" required id="rented" value="2" v-model="truck.truck_mode_id"> <label for="rented">&nbsp;Alquilado</label> <br>
                <input type="radio" required id="third" value="3" v-model="truck.truck_mode_id"> <label for="third">&nbsp;Tercero</label>
              </b-col>
            </b-row>

            <b-row class="form-group">
              <b-col sm="5">
                <label for>Año de fabricación</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="truck.manufacturing_year"
                  min="1900"
                  :max="max_year"
                />
              </b-col>
            </b-row>

            <b-row class="form-group">
              <b-col sm="5">
                <label for>Características*</label>
                <v-select
                  multiple
                  v-model="truck_types_selected"
                  label="name"
                  :options="truck_types"
                  :on-change="setCharacteristics"
                ></v-select>
              </b-col>
            </b-row>

            <b-row class="form-group">
              <b-col sm="5">
                <label for>Conductores</label>
                <v-select multiple v-model="drivers_selected" label="name" :options="drivers">
                  <template slot="option" slot-scope="option">{{option.name}} {{option.last_name}}</template>
                  <template
                    slot="selected-option"
                    slot-scope="option"
                  >{{option.name}} {{option.last_name}}</template>
                </v-select>
              </b-col>
            </b-row>

            <b-row v-for="item in truckFields" :key="item.field" class="form-group">
              <b-col sm="5">
                <label for>{{item.label}}</label>
                <br />
                <date-picker v-model="truck[item.field]" lang="es" type="date" format="DD/MM/YYYY"></date-picker>
              </b-col>
            </b-row>
            <div slot="footer">
              <b-button type="submit" variant="primary">Guardar</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import constants from "@/constants";
import truckFields from "@/constants/truck";
import api from "@/helpers/api";
import moment from "moment";

export default {
  props: ["truck_id"],
  data() {
    return {
      max_year: moment().format("YYYY"),
      truck: {
        drivers: [],
        provider: {}
      },
      providers: [],
      provider: {},
      service_types: [],
      truck_types: [],
      truck_types_selected: [],
      drivers_selected: [],
      teams: [],
      team: {},
      carts: [],
      cart: {},
      drivers: [],
      truckFields
    };
  },
  mounted() {
    api.get("/providers").then(response => {
      this.providers = response.providers;
    });

    api.get("/drivers").then(response => {
      this.drivers = response.users;
    });

    api.get("/carts").then(response => {
      this.carts = response.carts;
    });

    api.get("/teams").then(response => {
      this.teams = response.teams;
    });

    api.get("/truck_types").then(response => {
      this.truck_types = response.truck_types.filter(tt => tt.name);
    });

    api.get("/service_types").then(response => {
      this.service_types = response.service_types.filter(
        st => [constants.INLAND, constants.PORTEO].indexOf(st.code) > -1
      );
    });

    if (this.truck_id) {
      api.get(`/truck/${this.truck_id}`).then(response => {
        this.truck = response.truck;
        this.truck_types_selected = this.truck.types;
        this.drivers_selected = this.truck.drivers;
      });
    }
  },
  methods: {
    setProvider(obj) {
      this.truck.provider_id = obj ? obj.id : null;
      this.truck.provider = obj ? obj : null;

      if(this.truck.provider.owner){
        this.truck.truck_mode_id = null;
      }
    },
    setTeam(obj) {
      this.truck.team_id = obj ? obj.id : null;
    },
    setDatetime(date) {
      return date ? moment(date).format("YYYY-MM-DD 23:59:59") : null;
    },
    setDrivers(obj, num) {
      this.truck.drivers = obj ? obj : [];
    },
    setCart(obj) {
      this.truck.cart_id = obj ? obj.id : null;
    },
    setCharacteristics(obj) {
      this.truck.characteristics = obj ? obj : [];
    },
    showError(label) {
      this.$toastr.error(label, "Error", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    send() {
      const { truck, truck_types_selected } = this;

      if (!truck.provider_id || !truck_types_selected.length) {
        this.showError("Debe llenar todos los campos obligatorios");
        return;
      }

      if(!truck.provider.owner && !truck.truck_mode_id){
        this.showError("Debes indicar modalidad de la unidad");
        return;
      }

      if(truck.provider.owner){
        this.truck.truck_mode_id = 1
      }

      truckFields.map(item => {
        this.truck[item.field] = this.setDatetime(truck[item.field]);
      });

      delete this.truck["cart"];
      delete this.truck["types"];
      delete this.truck["provider"];
      // return
      if (this.truck_id) {
        api
          .put(`/truck/${this.truck_id}`, this.truck)
          .then(
            response => {
              this.$toastr.success(`Camión actualizado.`, "Flota", {
                positionClass: "toast-top-center",
                closeButton: true
              });
              this.$router.push({
                path: `/fleet/list`
              });
            },
            error => {
              this.showError(error.message);
            }
          )
          .catch(error => {
            console.log(error.message);
          });
      } else {
        api.post("/truck", this.truck).then(
          response => {
            this.$toastr.success(`Camión registrado.`, "Flota", {
              positionClass: "toast-top-center",
              closeButton: true
            });
            this.$router.push({
              path: `/fleet/list`
            });
          },
          error => {
            this.showError(error.message);
          }
        );
      }
    }
  }
};
</script>
